module.exports = __webpack_public_path__ + "static/woodenrattle-82535189adb21aef4e6d0c3c99e38439.jpeg";